module.exports = __webpack_public_path__ + "static/media/img_action_bar_page_ios.ed641015.png";